/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Authenticate with {providerName}',
    id: 'AwaitingThirdpartyAuthentication.title',
  },
  titleApp: {
    defaultMessage: 'Authenticate with the {providerAppName} app',
    id: 'AwaitingThirdpartyAuthentication.titleApp',
  },
  step2: {
    defaultMessage: 'You will be required to authenticate.',
    id: 'AwaitingThirdpartyAuthentication.step2',
  },
  step3: {
    defaultMessage:
      'Once authenticated, you will be redirected back to {clientName}{isAbbreviated, select, true {} other {.}}',
    id: 'AwaitingThirdpartyAuthentication.step3',
  },
  consentInformation: {
    defaultMessage:
      'Make sure to give consent for account balance and transaction in {providerName} for this service to work',
    id: 'AwaitingThirdpartyAuthentication.consentInformation',
  },
});
